import { render, staticRenderFns } from "./GroupPreviewModal.vue?vue&type=template&id=1d028826&"
import script from "./GroupPreviewModal.vue?vue&type=script&lang=js&"
export * from "./GroupPreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./GroupPreviewModal.vue?vue&type=style&index=0&id=1d028826&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports